import { Component } from '@angular/core';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';

@Component({
  selector: 'app-pda-disclaimer',
  templateUrl: './pda-disclaimer.component.html',
  styleUrls: ['./pda-disclaimer.component.css']
})
export class PdaDisclaimerComponent {
  constructor(
    private dialogConfig : DialogConfig,
    private dialogRef : DialogRef
  ) { }
  
  onAction(event: boolean) {
    this.dialogRef.close({modalEvent : event});
  }
}
